export default __webpack_public_path__ + "static/media/dash-logo.17d2f3fb.svg";